export default {
  engagementTemplates(state) {
    return state.engagementTemplates;
  },
};
